export const CUSTOM_EVENTS = {
  SSO_SIGN_IN: 'SSO_SIGN_IN',
  TAB_CHANGE_TO_: 'TAB_CHANGE_TO_',
};
